import { SET_DATE, SET_FULLTEXT, SET_HDBL, SET_ONLINE, SET_OFFLINE, RESET } from '../types/filters'

const initialState = {
    hdbl: true,
    online: true,
    offline: true,
    phrase: null,
    date: null,
}

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case SET_DATE:
            return Object.assign({}, state, {
                date: action.data
            })
        case SET_FULLTEXT:
            return Object.assign({}, state, {
                phrase: action.data
            })
        case SET_HDBL:
            return Object.assign({}, state, {
                hdbl: action.data
            })
        case SET_ONLINE:
            return Object.assign({}, state, {
                online: action.data
            })
        case SET_OFFLINE:
            return Object.assign({}, state, {
                offline: action.data
            })
        case RESET:
            return Object.assign({}, state, {
                date: null
            })
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/filters.js